export default __webpack_public_path__ + "static/media/group_slide.9973379d.svg";